// Machine-drafted — review with a native speaker before launch.
const engagement = {
	engagement: {
		// Engagement page
		title: 'Engagement',
		last7Days: '7 derniers jours',
		last15Days: '15 derniers jours',
		last30Days: '30 derniers jours',
		last2Months: '2 derniers mois',
		last6Months: '6 derniers mois',
		lastYear: 'Dernière année',
		allCards: 'Toutes les cartes',
		statContactEngagement: 'Engagement des contacts',
		statEmailsOpened: 'E-mails ouverts',
		statCardsOpened: 'Cartes ouvertes',
		statTotalReactions: 'Réactions totales',
		statTotalComments: 'Commentaires totaux',
		statTotalDownloads: 'Téléchargements totaux',
		cardEngagement: 'Engagement de la carte',
		noSentCards: "Aucune carte envoyée trouvée. Envoyez une carte pour voir les données d'engagement.",
		untitled: 'Sans titre',
		cardAlt: 'Carte',
		loading: 'Chargement...',
		analytics: 'Analytique',
		reactions: 'Réactions',
		noReactions: 'Aucune réaction',
		comments: 'Commentaires (%{count})',
		anonymous: 'Anonyme',
		noComments: 'Aucun commentaire',
		// Contacts engagement list
		viewContacts: 'Voir les contacts',
		cardStats: 'Statistiques des cartes',
		mostEngagedContacts: 'Contacts les plus engagés',
		noContactsYet: "Vous n'avez pas encore de contacts.",
		tooltipCardsOpened: 'Nombre total de cartes ouvertes par ce contact',
		tooltipCardsSent: 'Nombre total de cartes envoyées à ce contact',
		// Activities
		typeLabel: 'Type',
		optionClicks: 'Clics',
		impression: 'Impression',
		filterLabel: 'Filtre',
		optionLast10Days: '10 derniers jours',
		optionLast7Days: '7 derniers jours',
		newClick: '‘Nom de l’image’ a reçu un nouveau clic',
		justNow: "À l'instant",
		messengerRedirect: 'Quelqu’un depuis Messenger a été redirigé vers www.cardclan.io',
		conversion: 'Conversion',
		sourceLabel: 'Source : %{source}',
		newImpression: '‘Nom de l’image’ a reçu une nouvelle impression',
		oneHour: '1 h',
		twitterRedirect: 'Quelqu’un depuis Twitter a été redirigé vers www.cardclan.io',
	} as Record<string, string>,
};
export default engagement;
